export const stringToAnchor = (string: string) => {
  if (!string) return ''
  return string?.toLowerCase().replace(/ /g, '-')
}
